<section class="other-content" *ngFor="let content of otherContent">
  <ng-container *ngIf="isSeoContentActive && content.type === 'text'">
    <h2 *ngIf="content.value.title" class="title" [id]="content.value.title">{{ content.value.title }}</h2>
    <app-rich-content
      *ngIf="content.value.description"
      class="rich-content"
      [content]="content.value.description"
      [showParagraphMargin]="true"
    >
    </app-rich-content>
  </ng-container>
  <ng-container *ngIf="isSeoContentActive && content.type === 'faq'">
    <section [id]="content.type">
      <app-seo-faq-content
        [faqTitle]="content.type"
        [faqContent]="content.value"
      >
      </app-seo-faq-content>
    </section>
  </ng-container>
  <ng-container *ngIf="content.type === 'newsletter-subscription'">
    <app-page-content-wrapper [contentWidth]="'95vw'" [contentPadding]="'0px'">
      <app-newsletter
        [source]="source"
        [isSmallSize]="hasSmallSize()"
        [isSubsidiaryAccount]="isSubsidiaryAccount$ | async"
        [NLDiscount]="NLDiscount"
      ></app-newsletter>
    </app-page-content-wrapper>
  </ng-container>
</section>
